import api from "./api";

// fetch watoms pdms forms titles
export const fetchWatomsPdmsForms = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/pdms/forms`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.forms || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.forms || error.message
    );
    throw error;
  }
};

// fetch wisdom pdms forms titles
export const fetchWisdomPdmsForms = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/pdms/forms`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.forms || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.forms || error.message
    );
    throw error;
  }
};

// fetch pedagogical test
export const fetchPedagogicalTest = async () => {
  try {
    const response = await api.get(`/api/v1/pdms/pedagogicalTest`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.test || {};
  } catch (error) {
    console.error(
      "Error fetching test:",
      error.response?.test || error.message
    );
    throw error;
  }
};

// submit mcq exam answers
export const postMcqExamAnswers = async (data) => {
    try {
        const response = await api.post('/api/v1/pdms/mcqExam', data);
        return response?.data || {};
    } catch (error) {
        console.error('Error submitting exam answers:', error);
        throw error;
    }
};

// fetch dashboard Data
export const fetchPdmsDashboard = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/pdms/dashboard`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.dashboard || {};
  } catch (error) {
    console.error(
      "Error fetching test:",
      error.response?.dashboard || error.message
    );
    throw error;
  }
};

// fetch dashboard Data
export const fetchWatomsPdmsDashboard = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/pdms/dashboard`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.dashboard || {};
  } catch (error) {
    console.error(
      "Error fetching test:",
      error.response?.dashboard || error.message
    );
    throw error;
  }
};